export default {
  account: {
    attributes: {
      name: 'Name',
      type: 'Type',
    },
    header: {
      title: 'Email service',
      subtitle: 'Learn how to integrate an email service',
      searchAccount: 'Search for an Account',
    },
    list: {
      insert_date: 'Added on',
      actions: 'Actions',
      deprecated: 'Deprecated',
    },
    editModal: {
      header: 'Add email service account',
      helpBlock: 'Please fill in the form below.',
      select: 'Select',
      save: 'Save',
      activeCampaign: {
        apiKey: 'Key',
        apiKeyPlaceholder: 'API Key',
        apiUrl: 'URL',
        apiUrlPlaceholder: 'API URL',
      },
      aweber: {
        help: 'To conclude integration with Aweber, click on Save below.',
      },
      convertKit: {
        apiKey: 'Key',
        apiKeyPlaceholder: 'API Key',
        apiSecret: 'Secret',
        apiSecretPlaceholder: 'API Secret',
      },
      eGoi: {
        apiKey: 'Your API Key',
      },
      getResponse: {
        apiKey: 'GetResponse API Key',
        apiKeyPlaceholder: 'API Key',
      },
      mailChimp: {
        apiKey: 'Mailchimp API Key',
        apiKeyPlaceholder: 'API Key',
      },
      rdStation: {
        apiKey: 'Your Token',
        apiKeyPlaceholder: 'Token',
        help: 'To finish the integration with RD Station, click the Save button below.',
      },
    },
    types: {
      getResponse: 'GetResponse',
      activeCampaign: 'Active Campaign',
      aweber: 'Aweber',
      convertKit: 'ConvertKit',
      eGoi: 'E-Goi',
      mailChimp: 'MailChimp',
      rdStation: 'RD Station',
    },
    actions: {
      new: 'NEW ACCOUNT',
      open: 'Open',
      edit: 'Edit',
      delete: 'Delete',
    },
    empty: {
      title: 'Make everything easier with Hotmart Send or integrate your email services with your pages',
      subtitle: 'Discover our email service to capture leads (contacts),<br/>create segmentations and send emails. You can also connect accounts from other services.',
      link: 'Learn how to integrate an email server  ',
      klicksend: 'Learn about Hotmart Send',
      button: 'Integrate another email',
      url: 'https://klickpageshelp.zendesk.com/hc/pt-br/sections/360010144511-Conta-Integrada',
      urlExtensions: 'https://help.hotmart.com/pt-BR/section/criador-de-paginas-formulario-de-pesquisa/360012998471',
    },
    notify: {
      success: {
        delete: 'Email service successfully deleted.',
        create: 'Email service successfully saved.',
        update: 'Email service successfully updated.',
      },
      error: {
        aweber: 'There was an error connecting to Aweber',
        rdstation: 'There was an error while connecting to RDStation',
      },
    },
  },
  modal: {
    delete: {
      title: 'DELETE',
      message: 'Are you sure you wish to delete this email service? This action cannot be undone!',
      confirm: 'YES, delete',
      cancel: 'Cancel',
    },
  },
  notifications: {
    noNotifications: 'There are no new notifications.',
    unableLoad: 'We were unable to load notifications at this time.',
  },
};



// WEBPACK FOOTER //
// ./src/i18n/messages/languages/enUs.js